import React from "react";
import {
  FormControl,
  FormControlLabel,
  RadioGroup,
  Radio,
  Typography,
} from "@mui/material";

export const StatusFilterGroup = ({
  value,
  onStatusChange,
  labels,
  totalAdults,
  totalInfants,
  checkedInAdults,
  checkedInInfants,
}) => {
  return (
    <FormControl>
      <RadioGroup
        row
        aria-labelledby="status-filter-group-label"
        onChange={onStatusChange}
        value={value}
      >
        <FormControlLabel
          value={labels.ALL}
          control={<Radio />}
          label={
            <span style={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body2" sx={{ mr: 0.5, fontWeight: "bold" }}>
                All
              </Typography>
              <Typography component="span" variant="caption">
                ({totalAdults} + {totalInfants} INF)
              </Typography>
            </span>
          }
        />
        <FormControlLabel
          value={labels.CHECKED_IN}
          control={<Radio />}
          label={
            <span style={{ display: "flex", alignItems: "center" }}>
              <Typography variant="body2" sx={{ mr: 0.5, fontWeight: "bold" }}>
                Checked in
              </Typography>
              <Typography component="span" variant="caption">
                ({checkedInAdults} + {checkedInInfants} INF)
              </Typography>
            </span>
          }
        />
      </RadioGroup>
    </FormControl>
  );
};
